<div class="d-flex mt-3 cursor-pointer" data-uit="notification-navigate" [routerLink]="profileURL">
    <div class="mt-1" [ngClass]="severity == 'warn' ? 'warn-circle' : 'alert-circle'"></div>
    <div class="col ps-2">
        <h4 class="font-weight-bold" data-uit="notification-title">{{ title }}</h4>
        <p class="font-sm font-weight-light" data-uit="notification-desc">{{ text }}</p>
    </div>
</div>
